import { useState } from "react";
import { ShieldCheck, ShieldAlert, Shield } from "lucide-react";
import { deviceLocationLines } from "@/lib/deviceLocation";

const locText = (c) => {
  const d = c.distance_from_property_meters;
  const dist = d != null ? ` — ${Math.round(d)}m from property` : "";
  switch (c.location_verified) {
    case "verified": return `Location: verified${dist}`;
    case "outside_geofence": return `Location: outside expected area${dist}`;
    case "no_property_coords": return "Location: property address not mapped";
    default: return "Location: not available";
  }
};

const timeText = (c) => ({
  verified: "Time: verified",
  outside_window: "Time: outside expected window",
  no_reference_date: "Time: no reference date set",
}[c.timestamp_verified] || "Time: not available");

export function CustodyShield({ custody, deviceLocation = null, className = "" }) {
  const [open, setOpen] = useState(false);
  if (!custody) return null;

  const loc = custody.location_verified;
  const tm = custody.timestamp_verified;
  const amber = loc === "outside_geofence" || tm === "outside_window";
  const green = loc === "verified" && tm === "verified";
  const Icon = amber ? ShieldAlert : green ? ShieldCheck : Shield;
  const color = amber ? "text-amber-600" : green ? "text-emerald-600" : "text-slate-400";
  const hashed = custody.has_hash || custody.sha256;

  return (
    <div className={`relative ${className}`}>
      <button
        type="button"
        data-testid="custody-shield"
        onClick={(e) => { e.stopPropagation(); e.preventDefault(); setOpen((o) => !o); }}
        className={`grid place-items-center h-7 w-7 rounded-full bg-white shadow-sm border border-black/5 ${color}`}
        aria-label="Photo verification status"
      >
        <Icon size={15} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={(e) => { e.stopPropagation(); e.preventDefault(); setOpen(false); }} />
          <div
            data-testid="custody-popover"
            onClick={(e) => e.stopPropagation()}
            className="absolute z-50 top-9 right-0 w-60 rounded-xl border border-[#E2E8F0] bg-white p-3 shadow-xl text-left"
          >
            <p className="text-xs font-bold text-navy mb-1.5">Photo verification</p>
            <p className="text-xs text-[#475569]">{locText(custody)}</p>
            <p className="text-xs text-[#475569] mt-1">{timeText(custody)}</p>
            {hashed && <p className="text-xs text-[#475569] mt-1">Integrity: SHA-256 hashed at upload</p>}
            {deviceLocation && (
              <div className="mt-2 pt-2 border-t border-[#E2E8F0]" data-testid="custody-device-location">
                {deviceLocationLines(deviceLocation).map((line, i) => (
                  <p key={i} className={`text-xs ${i === 0 ? "font-medium text-navy" : "text-[#475569]"} ${i > 0 ? "mt-0.5" : ""}`}>{line}</p>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
